import * as React from "react";
import Tooltip from '@material-ui/core/Tooltip';

export class BadgeRow extends React.Component {

    render() {
        if (!this.props.badges) {
            return (<div></div>);
        } else {
            const filteredBadgeTiers = Object.values(this.props.badges.reduce((acc, cur) => {
                acc[cur.idAchievementGroup] = acc[cur.idAchievementGroup] && acc[cur.idAchievementGroup].tier > cur.tier ? acc[cur.idAchievementGroup] : cur
                return acc
            }, {}))
            return (<div style={{ marginLeft: '1em', marginBottom: '1em' }}>
                {filteredBadgeTiers.map((curBadge, idx) => {
                    if (curBadge.image) {
                        return (
                            <Tooltip key={idx} placement="top" title={curBadge.name}>
                                <img style={{ marginRight: '10px' }} width="30px" src={`${window.globals.STATIC_ASSETS_BASE_URL}/unversioned/images/badges/${curBadge.image}`} />
                            </Tooltip>
                        )
                    }
                })}
            </div>)
        }
    }

};
